import React, {useEffect} from "react";
import {BrowserRouter as Router} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Alerts from "./components/Alerts";
import ErrorBoundary from "./components/ErrorBoundary";
import Main from "./components/Main";
import AICooldownProvider from "./context/AICooldownProvider";
import AlertProvider from "./context/AlertProvider";
import {AuthzProvider} from "./context/AuthzProvider";
import {ConsolidatedThemeProvider} from "./context/ConsolidatedThemeProvider";
import {FeatureFlagProvider} from "./context/FeatureFlagProvider";
import {GraphQLClientProvider} from "./context/GraphQLClientProvider";
import {RegScoutGraphQLClientCacheProvider} from "./context/RegScoutGraphQLClientCacheProvider";
import {IdleTimerProvider} from "./context/IdleTimerProvider";
import {OrgSettingsProvider} from "./context/OrgSettingsProvider";
import {ThemeWrapperProvider, useTheme} from "./context/ThemeWrapperProvider";
import {AuthWrapper} from "./components/authentication/AuthWrapper";
import {NetworkErrorProvider} from "./components/errors/Context/NetworkErrorProvider";
import {SidebarProvider} from "./components/sidebar/Context/SidebarProvider";
import {TourProvider} from "./components/tour/Context/TourProvider";
import {UserProvider} from "./components/user/Context/UserProvider";
import {Sidebar} from "./components/sidebar/Sidebar";
import {Topbar} from "./components/topbar/Topbar";
import {consoleTagline, initializeDayJS, initializeDOMPurify} from "./resources/environment";
import {initializeMetrics} from "./resources/metrics";
import PlatformRoutes from "./Routes";

const App = () => {
  return (
    <ThemeWrapperProvider>
      <AppContent />
    </ThemeWrapperProvider>
  );
};

const AppContent = () => {
  const {activeTheme} = useTheme();

  useEffect(() => {
    console.log(consoleTagline);
    initializeDayJS();
    initializeDOMPurify();
    initializeMetrics();
  }, []);

  return (
    <FeatureFlagProvider>
      <NetworkErrorProvider>
        <ConsolidatedThemeProvider activeTheme={activeTheme}>
          <AuthWrapper>
            <GraphQLClientProvider>
              <RegScoutGraphQLClientCacheProvider>
                <UserProvider>
                  <AuthzProvider>
                    <OrgSettingsProvider>
                      <Router
                        future={{
                          v7_startTransition: true,
                        }}
                      >
                        <CssBaseline />
                        <AlertProvider>
                          <Alerts />
                          <IdleTimerProvider>
                            <AICooldownProvider>
                              <TourProvider>
                                <SidebarProvider>
                                  <Topbar />
                                  <Sidebar />
                                  <Main>
                                    <ErrorBoundary>
                                      <PlatformRoutes />
                                    </ErrorBoundary>
                                  </Main>
                                </SidebarProvider>
                              </TourProvider>
                            </AICooldownProvider>
                          </IdleTimerProvider>
                        </AlertProvider>
                      </Router>
                    </OrgSettingsProvider>
                  </AuthzProvider>
                </UserProvider>
              </RegScoutGraphQLClientCacheProvider>
            </GraphQLClientProvider>
          </AuthWrapper>
        </ConsolidatedThemeProvider>
      </NetworkErrorProvider>
    </FeatureFlagProvider>
  );
};

export default App;
